import { render, staticRenderFns } from "./ApproveAction.vue?vue&type=template&id=26cff22a&"
import script from "./ApproveAction.vue?vue&type=script&lang=js&"
export * from "./ApproveAction.vue?vue&type=script&lang=js&"
import style0 from "./ApproveAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports